export const SOURCE_YOUTUBE = 'youtube';
export const SOURCE_VIMEO = 'vimeo';
export const SOURCE_OTHER = 'other';

export const VIDEO_SOURCES_OPTIONS = [
  { label: 'YouTube', value: SOURCE_YOUTUBE },
  { label: 'Vimeo', value: SOURCE_VIMEO },
  { label: 'Other', value: SOURCE_OTHER },
];

export const DEFAULT_VIDEO_SOURCE = 'vimeo';
export const DEFAULT_VIDEO_SOURCE_OPTIONS = [{ label: 'Vimeo', value: SOURCE_VIMEO }];
